import baseURL from "../Api/baseURL";

const useInsertData = async (url, params) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      admin:true
    },
  };
  const res = await baseURL.post(url, params, config);
  return res.data;
};
const useInsertDataWithImage = async (url, params) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      admin:true
    },
  };
  const res = await baseURL.post(url, params, config);
  return res;
};

export { useInsertData, useInsertDataWithImage };
